import { Component } from "@angular/core";
import { FieldType, Guid } from "@kre-form/core";
import { KreFormAntService } from "../tools/service";

@Component({
  selector: "krefield-checkboxgroup",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <div class="control-design">
        <nz-checkbox-wrapper
          style="width: 100%;"
          (nzOnChange)="onChange($event)"
          [class.is-invalid]="showError"
        >
          <ng-container *ngFor="let option of to.options; let i = index">
            <label
              nz-checkbox
              [nzValue]="option.value"
              [ngModel]="getControlChecked(formControl.value, option)"
              [kreFormAttributes]="field"
              disabled
              >{{ option.label }}</label
            >
          </ng-container>
        </nz-checkbox-wrapper>
      </div>
    </ng-container>

    <ng-template #other>
      <ng-container *ngIf="editor === true">
        <nz-checkbox-wrapper
          style="width: 100%;"
          (nzOnChange)="onChange($event)"
          [class.is-invalid]="showError"
        >
          <ng-container *ngFor="let option of to.options; let i = index">
            <label
              nz-checkbox
              [nzValue]="option.value"
              [ngModel]="getControlChecked(formControl.value, option)"
              [kreFormAttributes]="field"
              >{{ option.label }}</label
            >
          </ng-container>
        </nz-checkbox-wrapper>
        <!-- <div class="tips">
          <i
            class="icon-bangzhu"
            [nzTooltipTitle]="tips"
            nzTooltipPlacement="top"
            nz-tooltip
            *ngIf="tips != ''"
          ></i>
        </div> -->
      </ng-container>
      <div class="fieldtext" *ngIf="editor === false">{{ textMultiple }}</div>
    </ng-template>
  `,
})
export class KreFormFieldCheckboxGroup extends FieldType {
  guid: any = Guid.create()["value"];

  onChange(values: string[]) {
    let res: any = [];
    if (values != undefined && values != null && values.length > 0) {
      values.forEach((value) => {
        if (this.to.options !== undefined && this.to.options !== null) {
          this.to.options.forEach((option: any) => {
            if (option["value"] === value) {
              res.push(value);
            }
          });
        }
      });
    }
    this.formControl.patchValue(values);
    this.formControl.markAsTouched();
  }

  getCheckStatus(option: any) {
    this.formControl.value;
  }

  public getControlChecked(values: any, option: any) {
    let result = false;
    if (option && values) {
      result = values.some((value: any) => {
        return value == option.value;
      });
    }
    return result;
  }
}

export interface ICheckValues {
  value: any;
}
